<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            <v-icon>mdi-clipboard-text</v-icon>Fitting Types
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text @click="formOpen = true">
              <v-icon>mdi-plus</v-icon>Add Fitting Type
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="fitting_types"
          :loading="loading"
          :options.sync="pagination" 
          :server-items-length="totalCount"
        >
          <template v-slot:item.actions="{item}">
            <v-btn icon small @click="editItem(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small @click="toggleItem(item)" v-if="item.status=='active'">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
            <v-btn icon small @click="toggleItem(item)" v-else>
              <v-icon small>mdi-check</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
      <list-form
        :item="editedItem"
        :open="formOpen"
        v-on:add="addItem()"
        v-on:cancel="cancelItem()"
        v-on:update="updateItem()"
      ></list-form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ListForm from "./_form";
import _ from "lodash";

export default {
  components: {
    ListForm
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Id", value: "id", align: "left" },
        { text: "Name", value: "name", align: "left" },
        { text: "Price", value: "price" },
        { text: "Status", value: "status" },
        { text: "Actions", value:'actions'}
      ],
      pagination: { itemsPerPage: 10 },
      formOpen: false,
      editedItem: null
    };
  },
  watch: {
    pagination: {
      handler: _.debounce(function() {
        this.getLists();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.getLists();
      }, 100)
    }
  },
  computed: {
    ...mapGetters('fittingTypes', ['fitting_types', 'loading', 'totalCount'])
  },
  mounted: function() {
    this.getLists(); //method1 will execute at pageload
  },
  methods: {
    getLists() {
      this.$store.dispatch("fittingTypes/index", {
        pagination: this.pagination,
        search: this.search
      });
    },
    addItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    updateItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    cancelItem() {
      this.formOpen = false;
      this.editedItem = null;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.formOpen = true;
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store
          .dispatch("fittingTypes/delete", {
            model: item
          })
          .then(() => {
            this.getLists();
          });
    },
    toggleItem(item){
      this.$store.dispatch("fittingTypes/toggle",{
        model:item
      })
      .then(() => {
        this.getLists();
      })
    }
  }
};
</script>
